import React from 'react';
import { Leaf } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="/assets/logo.png" 
                alt="CROMAN Logo" 
                className="h-10 w-10 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold">CROMAN</h3>
                <p className="text-xs text-gray-400">Premium Mandarin Processing</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Deep mandarin processing excellence from Croatia. Quality mandarin products for global markets.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Products</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="hover:text-orange-400 transition-colors cursor-pointer">Juice Powder</li>
              <li className="hover:text-orange-400 transition-colors cursor-pointer">Mandarin Aroma</li>
              <li className="hover:text-orange-400 transition-colors cursor-pointer">Mandarin Pellets</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <a href="tel:+385955826542" className="hover:text-orange-400 transition-colors">
                  +385 95 582 6542
                </a>
              </li>
              <li>
                <a href="mailto:info@croman.eu" className="hover:text-orange-400 transition-colors">
                  info@croman.eu
                </a>
              </li>
              <li className="text-gray-500">Croatia</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} CROMAN. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <Leaf className="w-4 h-4 text-green-500" />
              <span>Sustainable Mandarin Processing</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;